export default {
    methods: {
        subscribeRowClickMutation() {
            if (typeof this.options.rowClickCallback === 'function') {
                this.$store.subscribe((mutation, state) => {
                    if (mutation.type == `${this.name}/ROW_CLICK`) {
                        const payload = mutation.payload;

                        if (this.allowClickEvent(payload.event)) {
                            this.options.rowClickCallback(
                                payload.row,
                                payload.event,
                            );
                        }
                    }
                });
            }
        },

        /**
         * @param  {Object}
         * @return {Boolean}
         */
        allowClickEvent(e) {
            const className = e.target.className;
            const type = e.target.type;

            if (
                className == 'indigo' ||
                $(e.target).has('input[type=checkbox]').length > 0 ||
                type == 'checkbox'
            ) {
                return false;
            }

            return true;
        },
    },

    mounted() {
        this.subscribeRowClickMutation();
    },
};



// WEBPACK FOOTER //
// ./resources/assets/js/plugins/vuetable2-checkbox/mixins/row-click.js